import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=71097c8a&scoped=true&"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavigation.vue?vue&type=style&index=0&id=71097c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71097c8a",
  null
  
)

export default component.exports